import { render, staticRenderFns } from "./ProfileOneClickSettings.vue?vue&type=template&id=86ba9a6e&scoped=true&"
import script from "./ProfileOneClickSettings.vue?vue&type=script&lang=js&"
export * from "./ProfileOneClickSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOneClickSettings.vue?vue&type=style&index=0&id=86ba9a6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ba9a6e",
  null
  
)

export default component.exports